import '@picocss/pico';
import Alpine from 'alpinejs';
import feather from 'feather-icons';

window.feather = feather;
window.Alpine = Alpine;

Alpine.start();